module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/sample2-pc-5a8f3198ff5155896ea71d48c8a8e02c.jpg";